export const DefaultSubscriber = "premier-lotto"

export const QuickNotificationReport  = "QUICK NOTIFICATION"
export const FavouriteReport = "FAVOURITE"